import { useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import { theme } from "@/theme";
import { ImageAttributes } from "@/store";
import { TabContainer } from "@/components/TabContainer";
import { Carousel } from "@/components/carousel/Carousel";

export type Testimonial = {
  title: string;
  logo?: ImageAttributes;
  content: string;
};

export interface PressTestimonialsProps {
  startAtIndex?: number;
  testimonials: Testimonial[];
}

const PressTestimonials = ({
  startAtIndex = 0,
  testimonials,
}: PressTestimonialsProps) => {
  const [selectedIndex, setSelectedIndex] = useState(startAtIndex);

  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );

  if (testimonials.length === 0) {
    return null;
  }

  const testimonialTabs = testimonials.map((testimonial) => {
    return {
      label: testimonial.logo ? (
        <img className="w-24" {...testimonial.logo} alt={testimonial.title} />
      ) : (
        testimonial.title
      ),
      panel: (
        <div
          key={testimonial.title}
          className="press-testimonials-tab-panel-content mx-auto my-0 max-w-sm px-6 py-16 text-center sm:max-w-lg lg:max-w-2xl"
        >
          <p className="body text-lg leading-normal md:text-2xl md:leading-relaxed">
            {testimonial.content}
          </p>
        </div>
      ),
    };
  });

  const testimonialSlides = testimonials.map((testimonial) => (
    <div key={testimonial.title} className="text-center">
      {testimonial.logo ? (
        <img
          className="mx-auto my-0 inline-block w-24"
          src={testimonial.logo.src}
          alt={testimonial.title}
          height={testimonial.logo.height}
          width={testimonial.logo.width}
          loading={testimonial.logo.loading}
          style={{ backgroundImage: "unset" }}
        />
      ) : (
        <h3 className="title text-base md:text-xl">{testimonial.title}</h3>
      )}
      <p className="body mt-4 text-lg leading-normal md:text-2xl md:leading-relaxed">
        {testimonial.content}
      </p>
    </div>
  ));

  if (isSmallScreen) {
    return (
      <div className="bg-primary-50">
        <div className="px-6 py-12">
          <Carousel
            items={testimonialSlides}
            arrows="none"
            startAtIndex={selectedIndex}
            onSlideChange={setSelectedIndex}
          />
        </div>
      </div>
    );
  } else {
    return (
      <TabContainer
        tabs={testimonialTabs}
        startAtIndex={selectedIndex}
        label="Testimonials from the press"
        onTabClicked={(value: string) => setSelectedIndex(+value)}
      />
    );
  }
};

export { PressTestimonials };
